'use strict';

exports.__esModule = true;
exports.Option = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// World's most unintersting component. :) The real work happens in OptionWrapper.
var Option = exports.Option = function Option(props) {
  return _react2.default.createElement(
    'div',
    null,
    props.children
  );
};

Option.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes2.default.string
} : {};

exports.default = Option;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y-select/lib/components/Option/index.js
// module id = 573
// module chunks = 10